import React from 'react';

export const PanelIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="3" y="4.5" width="18" height="15" rx="2.6" stroke="currentColor" strokeWidth="1.7" />
    <path d="M9.25 4.5V19.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
  </svg>
);

export default PanelIcon;
